import axios from "axios";
import { abort } from "./request";
import i18n from "@/plugins/i18n";
import useAlert from "@/composables/useAlert";
import router from "@/router";
import { useAuthStore } from "@/stores";

export const resolve = (response) => {
    return Promise.resolve(response);
}


export const reject = error => {

    const { t: translate } = i18n().global;

    if(axios.isCancel(error)) {
        return Promise.reject(error);
    }
    
    if(error?.response?.status == 401 && !location.href.includes('auth/login') && !location.href.includes('portal-login')) {
        const authStore = useAuthStore();
        const wasClient = authStore.user?.role === 'client';
        abort();
        authStore.logout();
        useAlert(translate('errors.session-expired'), 'danger');
        router.push({ name: wasClient ? 'auth.client-login' : 'auth.login' });
    }

    if(error.response.status == 500) {
        if(error.data?.code == 'ERROR') {
            useAlert(translate(error.data?.error_message), 'danger')
        } else {
            useAlert(translate('errors.something-wrong-happened'), 'danger')
        }
    }

    return Promise.reject(error);
}